// extracted by mini-css-extract-plugin
export default {"Apercus":"ImporterCapteurCSV_Apercus__ffGbM","label":"ImporterCapteurCSV_label__CBVQ8"};